import React from 'react';

import PropTypes from 'prop-types';

import s from './SalonContact.module.css';

const formatPhone = (phone) => {
  const phoneTest = new RegExp(
    /^((\+1)|1)? ?\(?(\d{3})\)?[ .-]?(\d{3})[ .-]?(\d{4})( ?(ext\.? ?|x)(\d*))?$/,
  );

  const results = phoneTest.exec(phone.trim());

  if (results !== null && results.length > 8) {
    return `(${results[3]}) ${results[4]}-${results[5]}${
      typeof results[8] !== 'undefined' ? ` x${results[8]}` : ''
    }`;
  }

  return phone.trim();
};

const formatPhoneLink = (phone) =>
  `tel:+1-${formatPhone(phone).replace(/[()]/g, '').replace(' ', '-')}`;

const SalonContact = ({ businessEmail, businessPhone, cellPhone }) => (
  <>
    {businessPhone && (
      <a className={s.userPhone} href={formatPhoneLink(businessPhone)}>
        {formatPhone(businessPhone)}
      </a>
    )}
    {businessEmail && (
      <div>
        {businessPhone && <span>or</span>}
        <span className={s.userEmail}>{businessEmail}</span>
      </div>
    )}
    {!businessPhone && !businessEmail && (
      <a className={s.userPhone} href={formatPhoneLink(cellPhone)}>
        {formatPhone(cellPhone)}
      </a>
    )}
  </>
);

SalonContact.propTypes = {
  businessEmail: PropTypes.string,
  businessPhone: PropTypes.string,
  cellPhone: PropTypes.string,
};

export default SalonContact;
